import { render, staticRenderFns } from "./SellCoinsSoldChart.vue?vue&type=template&id=016dbe56&scoped=true&"
import script from "./SellCoinsSoldChart.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsSoldChart.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsSoldChart.vue?vue&type=style&index=0&id=016dbe56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016dbe56",
  null
  
)

export default component.exports